import { render, staticRenderFns } from "./top-info.vue?vue&type=template&id=1bc9ecd3&scoped=true&"
import script from "./top-info.vue?vue&type=script&lang=js&"
export * from "./top-info.vue?vue&type=script&lang=js&"
import style0 from "./top-info.vue?vue&type=style&index=0&id=1bc9ecd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc9ecd3",
  null
  
)

export default component.exports